import gsap from "gsap"
import style from './Roadmap.module.css'
import { useEffect, useState } from "react"
import logo from '../assets/Your paragraph text.png';


export default function Roadmap()
{
    useEffect(() => {
        gsap.fromTo("#flashingText", {color: 'red',}, {color: "yellow", repeat: -1, yoyo: 'true'})
        gsap.fromTo("#flashingText", {x: -500}, {x: 500, repeat: -1, yoyo: 'true', duration: 10})
    })

    return(
        <div className = {style.Container}>
            <h2>Roadmap</h2>
            <h2>1) Launch Token On Solana </h2>

            <img className={style.Img} src = {logo} />

            <h2 className={style.Header} id = "flashingText">🚀 Roadmap </h2>
            <h2>2) </h2>

            <h2>1) Entertainment: </h2>
            <h2>1) Tip 8: look in up direction </h2>
            <h2>1) Tip 8: look in down direction </h2>
            <h2>1) Tip 8: stare in left direction </h2>
            <h2>1) Tip 8: look in right direction </h2>
            <h2>1) Tip 8: look in front direction </h2>
            <h2>1) Tip 8: look in back direction </h2>
            <p>Moral: there are 6 directions for looking</p>

        </div>
    )
}